"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTM_SEGMENT_CODE_MAP = exports.GTM_TAB_FILTER_CATEGORY = exports.GTM_PAGE_NAME = exports.PRODUCT_FILTER_EXTRA_CONFIGURATION = exports.DEFAULT_FILTER_CONFIGURATION = exports.DOCUMENT_TYPE_KEY = exports.TAB_KEY = exports.ALL_TAB_KEY = exports.HIERARCHIES_KEY = exports.EXCEPTIONAL_REFINEMENT_KEYS = exports.PUBLICATION_CHANNEL_DEFINITION_IDS_REFINEMENT_KEY = exports.ASSET_TYPE_REFINEMENT_KEY = exports.ICON_BY_TAB_KEY_MAP = exports.CHINA_LOCALE = exports.DATE_FORMAT = exports.SEARCH_QUERY_CHANGE_EVENT = void 0;
const typings_1 = require("./typings");
exports.SEARCH_QUERY_CHANGE_EVENT = 'searchQueryChange';
exports.DATE_FORMAT = 'LL';
exports.CHINA_LOCALE = 'zh-cn';
exports.ICON_BY_TAB_KEY_MAP = {
    [typings_1.SearchResultTabKeyEnum.Pages]: 'list-note-outline',
    [typings_1.SearchResultTabKeyEnum.Products]: 'settings-outline',
    [typings_1.SearchResultTabKeyEnum.Documents]: 'draft-outline',
    [typings_1.SearchResultTabKeyEnum.Drawings]: 'image-outline',
    [typings_1.SearchResultTabKeyEnum.Downloads]: 'file-download-outline',
};
// Filters
exports.ASSET_TYPE_REFINEMENT_KEY = 'assetType';
exports.PUBLICATION_CHANNEL_DEFINITION_IDS_REFINEMENT_KEY = 'publicationChannelDefinitionIds';
exports.EXCEPTIONAL_REFINEMENT_KEYS = new Set([
    exports.ASSET_TYPE_REFINEMENT_KEY,
    exports.PUBLICATION_CHANNEL_DEFINITION_IDS_REFINEMENT_KEY,
]);
exports.HIERARCHIES_KEY = 'hierarchies';
exports.ALL_TAB_KEY = 'all';
exports.TAB_KEY = 'tab';
exports.DOCUMENT_TYPE_KEY = 'type';
exports.DEFAULT_FILTER_CONFIGURATION = 'NOT segments:SDW AND NOT segments:SEMIKRON_DANFOSS AND NOT url:#';
exports.PRODUCT_FILTER_EXTRA_CONFIGURATION = 'AND NOT segments:DPS';
// GTM
exports.GTM_PAGE_NAME = 'Search page';
exports.GTM_TAB_FILTER_CATEGORY = 'type';
exports.GTM_SEGMENT_CODE_MAP = {
    DCS: 'Climate Solutions',
    DPS: 'Power Solutions',
    DPD: 'Drives',
};
